document.addEventListener("DOMContentLoaded", function () {

  /* ------------------------------
     SELECT BUTTON CLICK
  --------------------------------*/
    document.addEventListener("click", function(e){

    const selectBtn = e.target.closest(".six-select-atc");
    if(!selectBtn) return;

    const item = selectBtn.closest(".bundle-scent-item");
    const actionBox = item.querySelector(".scent-action");
    const qtyBox = item.querySelector(".qty-box");

    console.log("SELECT clicked");

    //  ADD THIS LINE (highlight parent)
    item.classList.add("is-selected");

    // Hide entire scent-action (removes background)
    actionBox.style.display = "none";

    // Show qty box
    qtyBox.style.display = "flex";

    // Reset quantity
    qtyBox.querySelector(".qty-number").innerText = "1";
       updateProgressBar();
       updateBundlePrice();
    });



  /* ------------------------------
     QTY PLUS
  --------------------------------*/
    document.addEventListener("click", function(e){

        if(!e.target.classList.contains("qty-plus")) return;

        const qtyBox = e.target.closest(".qty-box");
        const numberEl = qtyBox.querySelector(".qty-number");

        let qty = parseInt(numberEl.innerText);
        qty++;
        numberEl.innerText = qty;
       updateProgressBar();
       updateBundlePrice();
    });


  /* ------------------------------
     QTY MINUS
  --------------------------------*/
  document.addEventListener("click", function(e){

    if(!e.target.classList.contains("qty-minus")) return;

    const qtyBox = e.target.closest(".qty-box");
    const numberEl = qtyBox.querySelector(".qty-number");

    let qty = parseInt(numberEl.innerText);

    if(qty > 1){
    qty--;
    numberEl.innerText = qty;
    } else {

    const item = e.target.closest(".bundle-scent-item");
    const actionBox = item.querySelector(".scent-action");
    item.classList.remove("is-selected");
    qtyBox.style.display = "none";
    actionBox.style.display = "flex";

    }
    updateProgressBar();
    updateBundlePrice();
   
  });


        /* ------------------------------
            ADD TO CART
        --------------------------------*/
            document.addEventListener("click", function(e){
                const atcBtn = e.target.closest(".six-product-atc");
                if(!atcBtn) return;
                atcBtn.classList.add('loading');

                let items = [];
                /* -------------------------
                COLLECT SCENTS
                -------------------------*/
                document.querySelectorAll(".bundle-scent-item").forEach(function(item){
                    const qtyBox = item.querySelector(".qty-box");
                    if(qtyBox && qtyBox.style.display === "flex"){

                        const variantId = item.querySelector(".select-btn")?.dataset.variantId;
                        const qty = parseInt(qtyBox.querySelector(".qty-number")?.innerText) || 0;

                        if(variantId && qty > 0){
                            items.push({
                                id: variantId,
                                quantity: qty
                            });
                        }

                    }

                });


                /* -------------------------
                COLLECT ADDONS
                -------------------------*/
                document.querySelectorAll(".holiday-addon-wrapper").forEach(function(wrapper){

                    const qtyInput = wrapper.querySelector(".quantity__input");
                    const addonBtn = wrapper.querySelector(".holiday-addon-atc");

                    const qty = parseInt(qtyInput?.value) || 0;

                    if(qty > 0 && addonBtn?.dataset.variantId){

                        items.push({
                            id: addonBtn.dataset.variantId,
                            quantity: qty
                        });

                    }

                });


                /* -------------------------
                VALIDATION
                -------------------------*/
                if(items.length === 0){
                    alert("Please select at least one product.");
                    atcBtn.classList.remove('loading'); // remove loader here
                    const stickyBtn = document.querySelector(".product__sticky__bar-add-cart.loading");
                    if(stickyBtn){
                        stickyBtn.classList.remove("loading");
                    }
                    return;
                }

                console.log("Items going to cart:", items);


                /* -------------------------
                SEND TO CART
                -------------------------*/
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: items })
                })
                .then(res => res.json())
                .then(data => {
                    console.log("Added to cart:", data);
                window.location.href="/checkout"
                    // if (window.openSidecart) {
                    //     window.openSidecart();
                    //     if (window.fetchCart) window.fetchCart();
                    // }
                })
                .catch(err => {
                    console.error("Cart error:", err);
                })
                .finally(() => {
                    atcBtn.classList.remove('loading'); 
                    const stickyBtn = document.querySelector(".product__sticky__bar-add-cart.loading");
                    if(stickyBtn){
                        stickyBtn.classList.remove("loading");
                    }
                });

            });


    // addon selecion code start from here
         const qtyWrappers = document.querySelectorAll(".addon-qtty");
            qtyWrappers.forEach(wrapper => {
                const minusBtn = wrapper.querySelector(".minus");
                const plusBtn = wrapper.querySelector(".plus");
                const input = wrapper.querySelector(".quantity__input");

                plusBtn.addEventListener("click", function () {
                let value = parseInt(input.value) || 0;
                input.value = value + 1;
                updateBundlePrice();
                });

                minusBtn.addEventListener("click", function () {
                let value = parseInt(input.value) || 0;

                if (value > 1) {
                    input.value = value - 1;
                } else if (value === 1) {
                    input.value = 0;

                    const addonWrapper = wrapper.closest(".holiday-addon-wrapper");
                    const addonBtn = addonWrapper.querySelector(".holiday-addon-atc");

                    wrapper.style.display = "none";
                    addonBtn.classList.remove("active");
                    addonWrapper.classList.remove("active-addon");
                    addonBtn.style.display = "block";
                }
                   updateBundlePrice();
                });
            });

    /* -------------------------------------------------------
        ADDON SELECT BUTTON ("Add")
    ------------------------------------------------------- */
        const addonButtons = document.querySelectorAll(".holiday-addon-atc");

        addonButtons.forEach(btn => {
            btn.addEventListener("click", function () {
                console.log('test')
                const wrapper = btn.closest(".holiday-addon-wrapper");
                const qtyBox = wrapper.querySelector(".addon-qtty");
                const input = qtyBox.querySelector(".quantity__input");

                wrapper.classList.add("active-addon");
                btn.classList.add("active");
                btn.style.display = "none";

                qtyBox.style.display = "flex";
                input.value = 1;
                updateBundlePrice();
            });
        });


});


// Progress bar code
        function updateProgressBar() {

            let totalQty = 0;

            // Count quantities
            document.querySelectorAll(".bundle-scent-item.is-selected").forEach(item => {
                const qty = parseInt(item.querySelector(".qty-number")?.innerText) || 0;
                totalQty += qty;
            });

            console.log("Total Quantity:", totalQty);

            // 🔥 Loop through ALL progress containers (normal + sticky)
            document.querySelectorAll(".bundle-progress").forEach(progressContainer => {

                const steps = progressContainer.querySelectorAll(".step");
                const progressFill = progressContainer.querySelector(".progress-fill");

                if (!progressFill) return; // safety check

                const maxSteps = steps.length;

                // Remove active class
                steps.forEach(step => step.classList.remove("active"));

                const activeSteps = Math.min(totalQty, maxSteps);

                for (let i = 0; i < activeSteps; i++) {
                    steps[i].classList.add("active");
                }

                // Width logic
                let fillPercent = 0;

                if (totalQty === 1) fillPercent = 15;
                else if (totalQty === 2 || totalQty === 3) fillPercent = 40;
                else if (totalQty === 4 || totalQty === 5) fillPercent = 65;
                else if (totalQty >= 6) fillPercent = 100;

                progressFill.style.width = totalQty > 0 ? fillPercent + "%" : "0%";

            });
        }

    
    function updateBundlePrice() {

        let totalQty = 0;
        let bundleTotal = 0;
        let addonTotal = 0;

        /* -----------------------------
            1️ CALCULATE BUNDLE TOTAL
        -----------------------------*/
        document.querySelectorAll(".bundle-scent-item.is-selected").forEach(item => {
            const qty = parseInt(item.querySelector(".qty-number").innerText);
            totalQty += qty;
        });

        if(totalQty === 1) bundleTotal = 19.95;
        else if(totalQty === 2) bundleTotal = 29.90;
        else if(totalQty === 3) bundleTotal = 44.85;
        else if(totalQty === 4) bundleTotal = 51.80;
        else if(totalQty === 5) bundleTotal = 64.75;
        else if(totalQty >= 6) bundleTotal = totalQty * 9.95;

        /* -----------------------------
            2️ CALCULATE ADDON TOTAL
        -----------------------------*/
        document.querySelectorAll(".holiday-addon-wrapper.active-addon").forEach(wrapper => {

            const price = parseInt(wrapper.querySelector(".holiday-addon-atc").dataset.price); // in cents
            const qty = parseInt(wrapper.querySelector(".quantity__input").value) || 0;

            addonTotal += (price * qty) / 100; // convert cents to dollars
        });

        /* -----------------------------
            3️ FINAL TOTAL
        -----------------------------*/
            const finalTotal = bundleTotal + addonTotal;

            const priceWrapper = document.querySelector(".product-carttotal-text");
            const priceEl = document.getElementById("bundle-total-price");
            const stickyPriceEl = document.querySelector(".product__sticky__bar-add-cart .product-total-price");
            const stickyBtntextwrapper = document.querySelector(".sticky-text-wrapper");

            if(finalTotal > 0) {
                priceWrapper.style.display = "inline-block";
                priceEl.innerText = "$" + finalTotal.toFixed(2);
            if (stickyPriceEl) {
                stickyBtntextwrapper.style.display = "inline";
                stickyPriceEl.innerText = "$" + finalTotal.toFixed(2);
            }
                            
            } else {
                    priceWrapper.style.display = "none";
                    priceEl.innerText = "$0.00";
                        if (stickyPriceEl) {
                        stickyPriceEl.innerText = "$0.00";
                        stickyBtntextwrapper.style.display = "none";

                    }
                        

           
            }
        }


    document.addEventListener("click", function(e){
        const stickyBtn = e.target.closest(".product__sticky__bar-add-cart");
        if(!stickyBtn) return;

        const mainAtcBtn = document.querySelector(".six-product-atc");
        if(!mainAtcBtn) return;

        stickyBtn.classList.add("loading");
        mainAtcBtn.click();
    });
  